var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { version as clientVersion } from './package.json';
/**
 * Search Provider for CEWE onsite search API
 * @see http://git.cewe.lan/discover/cewe-onsitesearch-api
 */
export class CeweSearchProvider {
    /**
     *
     * @param config
     * @param state
     */
    constructor(config, state) {
        /**
         * global http header, send with every request.
         * @private
         */
        this.globalHeaders = {};
        /**
         * stack for requests abortcontroller
         * @private
         */
        this.aborts = [];
        this.config = config;
        this.appLocalState = state;
        this.globalHeaders = {
            // @TODO: use constants for keys
            'X-OSS-CLIENT': clientVersion !== null && clientVersion !== void 0 ? clientVersion : 'n/a',
            'X-OSS-KEYACCOUNT': String(this.config.keyAccount),
            'X-OSS-UUID': this.appLocalState.uuid,
            'X-OSS-RAND': this.appLocalState.rand,
        };
    }
    /**
     * executes a new search request and cancel previous requests.
     * @param query
     * @param additionalParameters
     * @throws Error
     */
    search(query, additionalParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            this.cancelPreviousRequests();
            const abortController = new AbortController();
            this.aborts.push(abortController);
            const request = {
                query: query,
                params: additionalParameters,
                keyAccount: (_a = this.config.keyAccount) !== null && _a !== void 0 ? _a : 0,
                language: (_b = this.config.language) !== null && _b !== void 0 ? _b : '',
                country: (_c = this.config.country) !== null && _c !== void 0 ? _c : '',
            };
            const response = yield this.postData(abortController, this.config.host + '/search', request);
            const jsonObj = yield response.json();
            if (jsonObj) {
                return jsonObj;
            }
            throw new Error('request failed');
        });
    }
    /**
     * returns if the remote service is ok.
     *
     * OK means: /health/check returns OK and service works like expected.
     */
    isReady() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.config.host + '/health/check', {
                cache: 'no-store',
                redirect: 'error',
                headers: Object.assign({}, this.globalHeaders),
            });
            const body = yield response.text();
            return body === 'OK';
        });
    }
    /**
     * @inheritDoc
     */
    trackResultItemClick(queryID, selectedItem, position, indexKey) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const response = yield this.postData(new AbortController(), this.config.host + '/tracking/click', {
                keyAccount: (_a = this.config.keyAccount) !== null && _a !== void 0 ? _a : '',
                language: (_b = this.config.language) !== null && _b !== void 0 ? _b : '',
                country: (_c = this.config.country) !== null && _c !== void 0 ? _c : '',
                index: indexKey,
                queryId: queryID,
                items: [
                    {
                        position: position,
                        objectID: selectedItem.objectID,
                    },
                ],
            });
            const body = yield response.text();
            return body === 'OK';
        });
    }
    /**
     *
     * @param query the query string to get the content
     * @param indicesConfig
     */
    getDynamicContentByQuery(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, indicesConfig = {}, filters) {
            var _a, _b, _c;
            this.cancelPreviousRequests();
            const maxResults = {};
            Object.keys(indicesConfig).forEach((indexName) => {
                if (indicesConfig[indexName].max) {
                    maxResults[indexName] = indicesConfig[indexName].max;
                }
            });
            const abortController = new AbortController();
            this.aborts.push(abortController);
            const request = {
                query: query,
                params: {
                    indices: Object.keys(indicesConfig) || [],
                    maxResults,
                    filters,
                },
                keyAccount: (_a = this.config.keyAccount) !== null && _a !== void 0 ? _a : 0,
                language: (_b = this.config.language) !== null && _b !== void 0 ? _b : '',
                country: (_c = this.config.country) !== null && _c !== void 0 ? _c : '',
            };
            const response = yield this.postData(abortController, this.config.host + '/content/dynamic_queried', request);
            const jsonObj = yield response.json();
            if (jsonObj) {
                return jsonObj;
            }
            throw new Error('request failed');
        });
    }
    /**
     * cancel all running requests.
     * @private
     */
    cancelPreviousRequests() {
        this.aborts.forEach((abortController) => abortController.abort());
        this.aborts = [];
    }
    /**
     * executes a cancelable json Post request.
     * @param abortController
     * @param url
     * @param data
     * @private
     */
    postData(abortController_1) {
        return __awaiter(this, arguments, void 0, function* (abortController, url = '', data = {}) {
            return yield fetch(url, {
                signal: abortController.signal,
                method: 'POST',
                headers: Object.assign({ 'Content-Type': 'application/json' }, this.globalHeaders),
                body: JSON.stringify(data), // body data type must match "Content-Type" header
            });
        });
    }
}
